import React, { Component } from 'react';
import './App.css';
import {Route, Link, BrowserRouter as Router} from 'react-router-dom';
import './index.css';
import EbookDetail from './comps/EbookDetail';
import Library from './comps/Library';
import Search from './comps/Search';
import {connect } from 'react-redux'
import ResetPassword from './comps/ResetPassword';
import TermsCondition from './comps/TermsCondition';
import RequestReset from './comps/RequestReset';

class App extends Component {

  render() {
    return (
      <Router>
        <div>
            {//<div style={{fontSize: 30, fontWeight: 700, color: 'rgb(30, 123, 133)', padding: '0 10px'}}><Link to="/library">Epub</Link></div>
            }

            <Route exact path="/" component={Library}/>
            <Route path="/library" component={Library}/>
            <Route path="/ebookdetail/:id" component={EbookDetail}/>
            <Route path="/search/:text" component={Search} />
            <Route path="/resetpassword" component={ResetPassword} />
            <Route path="/termscondition" component={TermsCondition} />
            <Route path="/requestreset" component={RequestReset} />
        </div>
    </Router>

    );
  }
}

export default connect(state => state)(App)
